import { MotiView } from "moti";
import React from "react";
import { View } from "react-native";

const Pagination = ({ containerStyle = {}, data = [], selectedIndex = 0,backgroundColor = "#000",thickness = 6 }) => {
  return (
    <View
      style={[{ flexDirection: "row", alignItems: "center" }, containerStyle]}
    >
      {data &&
        Array.isArray(data) &&
        data?.map((item, index) => (
          <MotiView
            key={index}
            style={{
              backgroundColor: backgroundColor,
              borderRadius: 100,
              marginHorizontal: 5,
            }}
            from={{
              opacity: 0.3,
              height: thickness,
              width: thickness,
            }}
            animate={
              selectedIndex == index
                ? {
                    opacity: 1,
                    height: thickness + 1,
                    width: thickness + 1,
                  }
                : {}
            }
          ></MotiView>
        ))}
    </View>
  );
};

export default Pagination;

// },
// dotStyle: {
//   width: 6,
//   height: 6,
//   borderRadius: 5,
//   marginHorizontal: 0,
//   backgroundColor: 'rgba(33, 36, 39, 1)',
// },
